import { createContext } from 'react';
import { MarketPerformanceChartContextType } from './useMarketPerformanceChartContext';

export const MarketPerformanceChartContext =
  createContext<MarketPerformanceChartContextType>(null);
